import React from 'react';
import { Container } from 'react-bootstrap';

const About = () => {
    return (
        <Container className="py-5 mt-5">
            <h2 className="metal-font display-6 text-center pb-3">About Us</h2>
            <p>
                This is a music school website. Here you can learn any kind of musical instrument. You can select your preferred music course. It is an educational institution specialized in the study, training, and research of music. Such an institution can also be known as a school of music, music academy, music faculty, college of music, music department, conservatory, conservatorium or conservatoire. In piano classes, students learn scales, arpeggios, and simple repertoire. A working knowledge of the piano is helpful, and many conservatory programs therefore require that students, regardless of their instrument, be able to demonstrate a basic level of keyboard proficiency. A music degree is worth it for most aspiring musicians. Music degrees are essential for employment in the music industry as well as building well-rounded musicians. However, in some areas of music, a degree may not be necessary.
            </p>
        </Container>
    );
};

export default About;